//https://elkfox.github.io/Ajaxinate/
export function initAjaxinate() {
  document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
      method: "click" // change to 'scroll' to enable autoload
    });
  });
}
